import { Typography } from '@material-ui/core';
import Breadcrumb from '../Breadcrumb';
import FollowDocument1 from './../../assets/FollowDocument-1.png';
import FollowDocument2 from './../../assets/FollowDocument-2.png';
import FollowDocument4 from './../../assets/FollowDocument-4.png';
import HelpFooter from './HelpFooter';
import useStyles from './useStyles';
import { useTranslation } from 'react-i18next';

export default function FollowDocument() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Breadcrumb
        name="topicName"
        data={{
          helpTopic: t('help.topics.documents.label'),
          helpTopicId: 'documents',
          topicName: t('help.subtopics.followUpDocument'),
          topicNameId: 'follow-up-document'
        }}
      />
      <Typography className={classes.title} component="p" variant="h4">
        {t('help.pages.followDocument.title')}
      </Typography>
      <Typography variant="body1">{t('help.pages.followDocument.step1')}</Typography>
      <img className={classes.media} src={FollowDocument1} alt={`${String(t('help.stepAltPrefix'))}1`} />
      <Typography variant="body1">{t('help.pages.followDocument.step2')}</Typography>
      <img className={classes.media} src={FollowDocument2} alt={`${String(t('help.stepAltPrefix'))}2`} />
      <Typography variant="body1">{t('help.pages.followDocument.step3')}</Typography>
      <img className={classes.media} src={FollowDocument4} alt={`${String(t('help.stepAltPrefix'))}3`} />
      <HelpFooter />
    </div>
  );
}
